export const extractLeafObjects = (obj) => {
  return Object.values(obj).flatMap(value => {
    if (typeof value === 'object' && value !== null) {
      const hasChildObject = Object.values(value).some(
        v => typeof v === 'object' && v !== null
      );

      if (!hasChildObject) {
        // Es un objeto hoja (no tiene objetos hijos)
        return [value];
      } else {
        // Aún hay más profundidad
        return extractLeafObjects(value);
      }
    }
    return [];
  });
}